import { appColors } from '@/src/theme/foundations/colors'
import { Box, type BoxProps, type FormLabelProps } from '@chakra-ui/react'
import { useMemo } from 'react'
import { generateTimeOptions } from '../utils/dateUtil'
import { FormSelect } from './Form/FormSelect'

interface SelectTimeInputProps extends Omit<BoxProps, 'onChange'> {
  value: string
  onChange: (val: string) => void
  label?: string
  labelFontSize?: string
  labelFontColor?: string
  stepMinutes?: number
  width?: string
  height?: string
  paddingY?: string
  isInvalid?: boolean
  isDisabled?: boolean
  isRequired?: boolean
  labelProps?: FormLabelProps
  errorMessage?: string
  menuPlacement?: 'bottom' | 'top'
}

const SelectTimeInput = ({
  value,
  onChange,
  label,
  labelFontSize = '14px',
  labelFontColor = appColors.secondaryForeground,
  stepMinutes = 15,
  width = '100px',
  height = '40px',
  paddingY = '2px',
  isInvalid = false,
  isDisabled = false,
  isRequired = false,
  errorMessage,
  menuPlacement,
  labelProps = {
    fontSize: labelFontSize,
    color: labelFontColor,
    fontWeight: 86,
  },
  ...props
}: SelectTimeInputProps) => {
  const options = useMemo(() => generateTimeOptions(stepMinutes), [stepMinutes])

  return (
    <Box display='flex' flexDirection='column' gap='4px' {...props}>
      <FormSelect
        name='select-time'
        label={label}
        labelProps={labelProps}
        isInvalid={isInvalid}
        errorMessage={errorMessage}
        value={value}
        onChange={(val: string) => onChange(val)}
        options={options}
        placeholder='HH:mm'
        width={width}
        height={height}
        controlProps={{
          py: paddingY,
        }}
        noIndicatorAnimation
        isDisabled={isDisabled}
        isRequired={isRequired}
        menuPlacement={menuPlacement}
      />
    </Box>
  )
}

export default SelectTimeInput
